import PermissionTable from "./PermissionTable";
import ReportView from "./ReportView";
import StyleEditor from "./StyleEditor";
import AdvancedEquation from "./AdvancedEquation";
import SearchPage from "./SearchPage";
import RequestTesting from "./RequestTesting";
import BlotOutlineBuilder from "./BlotOutlineBuilder";
import TimelineBuilder from "./TimelineBuilder";
import SupplementFiguresScene from "./SupplementFiguresScene";
import ResizableFlex from "./ResizableFlex";
import MolecularWeightInterpolation from "./MolecularWeightInterpolation";
import b64test from './b64test.txt';
import Scatter from "./Scatter";

import ScatterPlot from "./ScatterPlot";

import SupplementPackage from "./SupplementPackage";

import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom'; 
import { useStore } from 'react-redux';

import GelCreator from './GelCreator';
import CellCultureDesignForm from './CellCultureDesignForm';

import VirtualImagePreview from './VirtualImagePreview';

import SvgCropPlayground from './SvgCropPlayground';
import MultidimPlayground from './MultidimPlayground';

import ErrorIcon from '@material-ui/icons/Error';

import WesternBlotWorkspace from './WesternBlotWorkspace';

import BaselineEditor from './BaselineEditor';


const letters = Array.from("ABCDEFGHIJKLM");//NOPQRSTUVWXYZ");
const roman = ["i","ii","iii","iv","v","vi","vii","viii","ix","x"];
const numbers = [1,2,3,4,5,6,7,8,9,10];
const items = numbers.map(num => ({
  title:""+num,
  action:""+num,
  type:"number",
  data:[num],
  submenu:letters.map(letter => ({
    action:letter,
    title:letter,
    data:[num,letter],
    submenu:roman.map(rr => ({
      title:rr,
      action:rr,
      data:[num,letter,rr]
    }))
  }))
}))


// cut location
//

const structure = {
  root:{ children:["a","b"] }, 
  a:{ cut:0, next:"a1" },
  b:{ cut:50, next:"b1" },
  b1:{ children:["b1.1","b1.2"] }
}



export default function Playground(){

  const [ value, setValue ] = useState(0);

  //return <GroupManagement/>
  return <PermissionTable/>
  return <BlotOutlineBuilder/>





}
